import { Box, Flex, Heading } from '@modusign/design-system';
import { lightGray50 } from '@modusign/design-system/colors';
import PropTypes from 'prop-types';
import PropsType from 'props-type';

import ContentContainer from '@app/components/ContentContainer';
import LocalHeader from '@app/components/LocalHeader';
import MyProfile from '@app/components/MyProfile';
import SettingTabMenu from '@app/containers/SettingTabMenu';

const propTypes = {
  children: PropTypes.node.isRequired,
};

type SettingLayoutProps = PropsType<typeof propTypes>;

export function SettingLayout({ children }: SettingLayoutProps) {
  return (
    <ContentContainer
      backgroundColor={lightGray50}
      pb={['60px', null, '120px']}
      pt={['60px', '0px']}
    >
      <LocalHeader isHelpBtn>
        <Flex alignItems="center" justifyContent="space-between" width="100%">
          <Heading fontSize={['md', null, 'xl']} fontWeight="medium" lineHeight={1}>
            설정
          </Heading>
          <Box display={['none', null, 'block']}>
            <MyProfile />
          </Box>
        </Flex>
      </LocalHeader>
      <SettingTabMenu />
      {children}
    </ContentContainer>
  );
}

SettingLayout.propTypes = propTypes;

export default SettingLayout;
